import React, { useContext, useState, useEffect, Fragment } from "react";
import { Modal } from "react-bootstrap";

import styles from "./policy_info_modal.module.css";
import ApiActions from "api_actions";
import { BookingDataContext } from "containers/data_context";

import PolicyData from "./policy_data/policy_data";
import Button from "components/buttons/button/button";
import { CloseCircleOutlined } from "@ant-design/icons";

export default function PolicyInfoModal({ show, onHide, selectedRatesByRoom }) {
  const { property, channelId } = useContext(BookingDataContext);

  const { data: propertyData } = property;

  const [date, setDate] = useState();

  useEffect(() => {
    const getData = async () => {
      const data = await ApiActions?.getProperty(channelId);

      setDate(data?.data[0]);
    };
    getData();
  }, [channelId]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Dialog className={styles.modal}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6 className={styles.header}>Booking Terms & Conditions</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRatesByRoom &&
            Object.keys(selectedRatesByRoom)?.map((roomId) =>
              selectedRatesByRoom[roomId].selectedRates.map((ratePlan, index) => (
                <Fragment key={index}>
                  <PolicyData
                    allowedCards={date?.allowed_cards || []}
                    ratePlan={ratePlan}
                    property={propertyData.hotelPolicy}
                    checkInDate={date?.checkin_hour}
                    checkOutDate={date?.checkout_hour}
                  />
                </Fragment>
              )),
            )}
        </Modal.Body>
        <Modal.Footer>
          <Button className={styles.btn}>Accept</Button>
          <Button className={styles.cbtn} onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </Modal>
  );
}
